import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { LOCAL_STORAGE_KEYS } from '@/lib/local-storage-keys'

interface SandboxStore {
  isSandboxMode: boolean
  setIsSandboxMode: (enabled: boolean) => void
  clearSandbox: () => void
}

export const useSandboxStore = create<SandboxStore>()(
  // @ts-ignore - Known issue with Zustand 5.x and TypeScript strict mode with persist middleware
  persist(
    (set) => ({
      isSandboxMode: false,

      setIsSandboxMode: (enabled) => {
        set({ isSandboxMode: enabled })
      },

      clearSandbox: () => {
        set({ isSandboxMode: false })
      },
    }),
    {
      name: LOCAL_STORAGE_KEYS.SANDBOX,
    },
  ),
)
